// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Banner_bottomLine__1bMS3","Banner":"Banner_Banner__3Lqgc","main":"Banner_main__30Ezl"};